"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customScroll = void 0;

exports.customScroll = function (_a) {
  var colorIconSecondary = _a.colorIconSecondary;
  return {
    scroll: {
      '&::-webkit-scrollbar': {
        width: '6px'
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '3px',
        background: colorIconSecondary.normal
      },
      '&::-webkit-scrollbar-corner': {
        background: 'transparent'
      },
      '&::-webkit-scrollbar-button': {
        width: 0,
        height: 0,
        display: 'none'
      }
    }
  };
};